<template>
    <div>
        <b-form @submit.prevent="saveSubNotDanger()" data-vv-scope="formSubNotDanger">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="subNotDanger.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formSubNotDanger.name')" />
                    </b-form-group>
                </b-col>

                <!-- Categoría anterior (NO PELIGROSA del SGA antiguo) -->
                <b-col md="12" v-if="showOldCategorySelect">
                    <b-form-group>
                    <label>Categoría anterior</label>
                    <el-select 
                        v-model="subNotDanger.old_sga_category_id" 
                        clearable 
                        filterable 
                        size="medium"
                        placeholder="Seleccionar categoría anterior" 
                        name="old_sga_category_id"
                        popper-class="sga-select-dropdown"
                        class="w-100">
                        <el-option 
                        v-for="item in oldCategories" 
                        :key="item.id" 
                        :label="item.categoria"
                        :value="item.id">
                        </el-option>
                    </el-select>                        
                    </b-form-group>
                </b-col>

                <!-- Frases P (Consejos de prudencia) -->
                <b-col md="12">
                    <b-form-group>
                        <label>Consejos de prudencia <span class="text-danger">*</span></label>
                        <el-select
                            v-model="subNotDanger.prudence_tip_code_ids"
                            multiple
                            clearable
                            filterable
                            size="medium"
                            placeholder="Seleccionar frases P"
                            name="prudence_tip_code_ids"
                            class="w-100"
                            popper-class="sga-select-dropdown"
                            v-validate="'required|min_value:1'"
                            data-vv-as=" "
                        >
                            <el-option
                                v-for="item in prudenceTipCodes"
                                :key="item.id"
                                :label="item.code + ' - ' + (item.name || '')"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formSubNotDanger.prudence_tip_code_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in subNotDanger.sga_sub_not_danger_language"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelSubNotDanger">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormSubNotDanger',

    computed: {
        ...mapState('sgaSubNotDanger', ['subNotDanger', 'action', 'oldSgaNotDangerousCategories', 'prudenceTipCodes']),
        ...mapState('sgaVersions', ['activeGlobalVersion', 'mainVersionId']),

        hasValidLanguages() {
            return Array.isArray(this.subNotDanger.sga_sub_not_danger_language) &&
                this.subNotDanger.sga_sub_not_danger_language.length > 0;
        },

        // Alias para las categorías antiguas
        oldCategories() {
            return this.$store.state.sgaSubNotDanger.oldSgaNotDangerousCategories || [];
        },

        // Mostrar el select (categorías antiguas) solo si la sustancia
        // está asociada a la versión principal (main)
        showOldCategorySelect() {
            if (!(this.subNotDanger && this.subNotDanger.id)) {
                return false;
            }

            if (!this.activeGlobalVersion) {
                return false;
            }

            // Normalizar ID de versión activa
            var currentVersionId = (typeof this.activeGlobalVersion === 'object' && this.activeGlobalVersion.id) 
                ? this.activeGlobalVersion.id 
                : this.activeGlobalVersion;

            if (!this.mainVersionId) {
                return false;
            }

            // Verificar si la sustancia tiene versiones asociadas
            var hasVersions = this.subNotDanger.versions && Array.isArray(this.subNotDanger.versions);
            var shouldShow;
            
            if (hasVersions) {
                // Si la sustancia tiene versiones, verificar si está asociada a la versión principal
                var isAssociatedWithMainVersion = this.subNotDanger.versions.some(function(version) {
                    return (version.sga_version_id || version.id) === this.mainVersionId;
                }.bind(this));
                
                shouldShow = isAssociatedWithMainVersion;
            } else {
                shouldShow = currentVersionId === this.mainVersionId;
            }
            
            
            return shouldShow;
        }
    },

    mounted() {
        if (this.showOldCategorySelect) {
            this.getOldSgaNotDangerousCategories();
            this.getPrudenceTipCodesActives();
        }
    },

    methods: {
        ...mapActions('sgaSubNotDanger', [
            'createSubNotDangerSga', 
            'getSubNotDangerSga', 
            'updateSubNotDangerSga',
            'getOldSgaNotDangerousCategories',
            'getPrudenceTipCodesActives'
        ]),
        ...mapMutations('sgaSubNotDanger', ['setDefaultSubNotDangerSga', 'setSubNotDangerItemSga']),

        cancelSubNotDanger() {
            this.setDefaultSubNotDangerSga();
            this.$bvModal.hide('modal_create_subnotdanger');
        },

        async cancelAndGetSubNotDanger() {
            this.cancelSubNotDanger();
            await this.getSubNotDangerSga();
        },

        async saveSubNotDanger() {
            const isValid = await this.$validator.validateAll('formSubNotDanger');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateSubNotDangerSga(this.subNotDanger);
            } else {
                flag = await this.createSubNotDangerSga(this.subNotDanger);
            }

            if (flag) {
                this.cancelAndGetSubNotDanger();
            }
        }
    }
}
</script>
